import { FC } from 'react';

interface IProps {
	className?: string;
	height?: string;
	width?: string;
	fill?: string;
	onClick?: () => void;
}

export const OrderChangeIcon: FC<IProps> = () => (
	<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<g opacity='0.5' clipPath='url(#clip0_3208_2353)'>
			<path
				d='M10.3572 2.85718C8.98498 2.85718 7.85723 3.98493 7.85723 5.35718V12.3187L7.36616 12.4582C5.30696 13.0454 4.41103 15.525 5.6223 17.2908L7.2685 19.6903C7.32163 19.7676 7.38946 19.8337 7.46813 19.8848C7.54681 19.9359 7.63477 19.971 7.72701 19.9881C7.81925 20.0052 7.91395 20.004 8.00572 19.9845C8.09748 19.965 8.1845 19.9276 8.26181 19.8745C8.33913 19.8214 8.40522 19.7535 8.45632 19.6748C8.50742 19.5962 8.54252 19.5082 8.55962 19.416C8.57672 19.3237 8.57549 19.229 8.55599 19.1373C8.53648 19.0455 8.4991 18.9585 8.44596 18.8812L6.80254 16.4844C6.11955 15.4888 6.59568 14.1621 7.75678 13.831L8.76683 13.5436C8.91617 13.5011 9.04762 13.4111 9.14126 13.2873C9.2349 13.1634 9.28564 13.0124 9.2858 12.8572V5.35718C9.2858 4.75697 9.75703 4.28575 10.3572 4.28575C10.9574 4.28575 11.4287 4.75697 11.4287 5.35718V11.4286C11.4287 11.618 11.5039 11.7997 11.6379 11.9337C11.7718 12.0676 11.9535 12.1429 12.1429 12.1429H15.6111C17.2551 12.1429 18.5715 13.4593 18.5715 15.1033V19.2857C18.5715 19.4752 18.6468 19.6569 18.7807 19.7908C18.9147 19.9248 19.0964 20 19.2858 20C19.4752 20 19.6569 19.9248 19.7909 19.7908C19.9248 19.6569 20.0001 19.4752 20.0001 19.2857V15.1033C20.0001 12.6872 18.0272 10.7143 15.6111 10.7143H12.8572V5.35718C12.8572 3.98493 11.7295 2.85718 10.3572 2.85718Z'
				fill='black'
			/>
			<path
				d='M2.35201 0.209126L0.209155 2.35198C0.0752339 2.48593 0 2.66759 0 2.85701C0 3.04642 0.0752339 3.22808 0.209155 3.36203C0.343106 3.49595 0.524764 3.57118 0.714178 3.57118C0.903592 3.57118 1.08525 3.49595 1.2192 3.36203L2.85703 1.72419L4.49487 3.36203C4.62882 3.49595 4.81048 3.57118 4.99989 3.57118C5.18931 3.57118 5.37096 3.49595 5.50491 3.36203C5.63884 3.22808 5.71407 3.04642 5.71407 2.85701C5.71407 2.66759 5.63884 2.48593 5.50491 2.35198L3.36206 0.209126C3.2281 0.0752219 3.04644 0 2.85703 0C2.66763 0 2.48597 0.0752219 2.35201 0.209126Z'
				fill='black'
			/>
			<path
				d='M0.714178 7.14282C0.524748 7.14285 0.343088 7.21812 0.209155 7.35209C0.0752339 7.48604 0 7.66769 0 7.85711C0 8.04652 0.0752339 8.22818 0.209155 8.36213L2.35201 10.505C2.48597 10.6389 2.66763 10.7141 2.85703 10.7141C3.04644 10.7141 3.2281 10.6389 3.36206 10.505L5.50491 8.36213C5.63884 8.22818 5.71407 8.04652 5.71407 7.85711C5.71407 7.66769 5.63884 7.48604 5.50491 7.35209C5.37096 7.21816 5.18931 7.14293 4.99989 7.14293C4.81048 7.14293 4.62882 7.21816 4.49487 7.35209L2.85703 8.98992L1.2192 7.35209C1.08527 7.21812 0.903607 7.14285 0.714178 7.14282Z'
				fill='black'
			/>
			<path
				d='M2.85735 0C2.66791 0 2.48623 0.0752549 2.35228 0.209209C2.21832 0.343164 2.14307 0.524845 2.14307 0.714286V10C2.14307 10.1894 2.21832 10.3711 2.35228 10.5051C2.48623 10.639 2.66791 10.7143 2.85735 10.7143C3.04679 10.7143 3.22847 10.639 3.36243 10.5051C3.49638 10.3711 3.57164 10.1894 3.57164 10V0.714286C3.57164 0.524845 3.49638 0.343164 3.36243 0.209209C3.22847 0.0752549 3.04679 0 2.85735 0Z'
				fill='black'
			/>
		</g>
		<defs>
			<clipPath id='clip0_3208_2353'>
				<rect width='20' height='20' fill='white' />
			</clipPath>
		</defs>
	</svg>
);

export const VotingIcon: FC<IProps> = ({ width, height, fill }) => (
	<svg
		width={width || '18'}
		height={height || '20'}
		viewBox='0 0 18 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M16.9036 12.3854H0.585938C0.382812 12.3854 0.185312 12.3511 0 12.2859V19.4141C0 19.7376 0.262344 20 0.585938 20H16.9036C17.2272 20 17.4896 19.7376 17.4896 19.4141V12.2859C17.3043 12.3511 17.1068 12.3854 16.9036 12.3854Z'
			fill={fill || '#757575'}
		/>
		<path
			d='M0.585929 11.2135H16.9036C17.2754 11.2213 17.5698 10.8442 17.4721 10.4855L16.2169 5.46464C16.1517 5.20378 15.9173 5.02081 15.6484 5.02081H14.3099V7.53124C15.0865 7.56007 15.0859 8.67456 14.3099 8.70312H3.138C2.3614 8.67429 2.36198 7.5598 3.138 7.53124H3.17964V5.02081H1.84116C1.5723 5.02081 1.33792 5.20382 1.27273 5.46464L0.0174919 10.4855C-0.0262581 10.6605 0.0130778 10.846 0.124093 10.9882C0.235148 11.1304 0.4055 11.2135 0.585929 11.2135Z'
			fill={fill || '#757575'}
		/>
		<path
			d='M13.138 0.585938C13.138 0.262344 12.8757 0 12.5521 0H4.9375C4.61391 0 4.35156 0.262344 4.35156 0.585938V7.53125H13.138V0.585938ZM11.042 2.92473L8.53152 5.43516C8.3027 5.66398 7.93172 5.66398 7.70289 5.43516L6.4477 4.17996C6.21887 3.95117 6.21887 3.58016 6.4477 3.35133C6.67652 3.12254 7.04754 3.12254 7.27633 3.35133L8.11723 4.19219L10.2134 2.09609C10.4422 1.8673 10.8132 1.86723 11.042 2.09609C11.2708 2.32492 11.2708 2.69594 11.042 2.92473Z'
			fill={fill || '#757575'}
		/>
	</svg>
);

export const VoteAlertIcon: FC<IProps> = ({ width, height }) => (
	<svg
		width={width || '27'}
		height={height || '27'}
		viewBox='0 0 27 27'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<g clipPath='url(#clip0_3208_5482)'>
			<path
				d='M23.6432 23.5127C23.5498 23.0428 23.0879 22.5539 22.6112 22.4052C22.3217 22.3156 16.6875 21.9422 13.4992 21.9464C10.3109 21.9422 4.67674 22.3156 4.38723 22.4052C3.91262 22.555 3.44856 23.0438 3.35522 23.5127C3.2833 23.9036 3.26045 24.302 3.28719 24.6987C3.31007 25.0953 3.3809 25.4877 3.49813 25.8672C3.64737 26.3223 4.14729 26.7521 4.61768 26.8534C4.9093 26.9146 10.4538 27 13.4992 27C16.5446 27 22.0891 26.9146 22.3786 26.8534C22.849 26.7521 23.3489 26.3223 23.4982 25.8672C23.6154 25.4877 23.6862 25.0953 23.7091 24.6987C23.7365 24.3021 23.7144 23.9037 23.6432 23.5127Z'
				fill='#BE3646'
			/>
			<path
				d='M14.6221 2.97105V1.12166C14.6221 0.502185 14.1199 0 13.5004 0C12.8809 0 12.3787 0.502185 12.3787 1.12166V2.97105C12.3787 3.59053 12.8809 4.09271 13.5004 4.09271C14.1199 4.09271 14.6221 3.59053 14.6221 2.97105Z'
				fill='#BE3646'
			/>
			<path
				d='M6.69331 5.32453L5.38579 4.01701C4.94782 3.57904 4.23773 3.57904 3.79976 4.01701C3.36179 4.45498 3.36179 5.16507 3.79976 5.60304L5.10728 6.91056C5.54525 7.34853 6.25534 7.34853 6.69331 6.91056C7.13128 6.47259 7.13128 5.7625 6.69331 5.32453Z'
				fill='#BE3646'
			/>
			<path
				d='M21.8956 6.91084L23.2031 5.60332C23.641 5.16535 23.641 4.45526 23.2031 4.01729C22.7651 3.57932 22.055 3.57932 21.6171 4.01729L20.3095 5.32481C19.8716 5.76278 19.8716 6.47287 20.3095 6.91084C20.7475 7.34881 21.4576 7.34881 21.8956 6.91084Z'
				fill='#BE3646'
			/>
			<path
				d='M24.028 14.8416H25.8774C26.4968 14.8416 26.999 14.3394 26.999 13.7199C26.999 13.1004 26.4968 12.5982 25.8774 12.5982H24.028C23.4085 12.5982 22.9063 13.1004 22.9063 13.7199C22.9063 14.3394 23.4085 14.8416 24.028 14.8416Z'
				fill='#BE3646'
			/>
			<path
				d='M1.12074 14.8411H2.97014C3.58961 14.8411 4.0918 14.3389 4.0918 13.7194C4.0918 13.0999 3.58961 12.5977 2.97014 12.5977H1.12074C0.501266 12.5977 -0.000917912 13.0999 -0.000917912 13.7194C-0.000917912 14.3389 0.501266 14.8411 1.12074 14.8411Z'
				fill='#BE3646'
			/>
			<path
				d='M21.4217 13.4225C21.3558 9.1953 17.6691 5.776 13.5 5.776C9.33078 5.776 5.64254 9.19793 5.5782 13.4251C5.55746 15.8836 5.60176 18.3417 5.71109 20.7995C6.30541 20.7563 7.01205 20.7109 7.74242 20.6698C9.96781 20.5437 12.0466 20.4715 13.4456 20.4715H13.5511C14.9502 20.4715 17.0316 20.5437 19.2549 20.6698C19.9852 20.7114 20.6919 20.7563 21.2862 20.7995C21.3966 18.3407 21.4418 15.8817 21.4217 13.4225ZM13.5 17.9439C13.2659 17.9439 13.0371 17.8745 12.8425 17.7445C12.6479 17.6145 12.4962 17.4297 12.4067 17.2134C12.3171 16.9972 12.2937 16.7593 12.3393 16.5297C12.385 16.3002 12.4977 16.0893 12.6632 15.9238C12.8287 15.7583 13.0396 15.6456 13.2691 15.5999C13.4986 15.5543 13.7366 15.5777 13.9528 15.6673C14.169 15.7569 14.3539 15.9085 14.4839 16.1031C14.6139 16.2977 14.6833 16.5265 14.6833 16.7606C14.6833 17.0744 14.5586 17.3754 14.3367 17.5973C14.1148 17.8193 13.8138 17.9439 13.5 17.9439ZM14.7434 9.67676C14.6881 11.4323 14.6327 12.0498 14.5779 13.808C14.5656 14.0856 14.4466 14.3478 14.2458 14.5399C14.045 14.732 13.7779 14.8392 13.5 14.8392C13.2221 14.8392 12.9549 14.732 12.7541 14.5399C12.5533 14.3478 12.4344 14.0856 12.4221 13.808C12.3693 12.0519 12.3119 11.4349 12.2565 9.67676C12.2354 9.10038 12.7917 8.61206 13.5 8.61206C14.2082 8.61206 14.7656 9.10038 14.7434 9.67676Z'
				fill='#BE3646'
			/>
		</g>
		<defs>
			<clipPath id='clip0_3208_5482'>
				<rect width='27' height='27' fill='white' />
			</clipPath>
		</defs>
	</svg>
);
